import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  Button,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const CourseModules = () => {
  const [expanded, setExpanded] = useState({});

  const handleToggle = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const moduloData = [
    {
      title: "MODULO I: FISICA E INSTRUMENTACION (BOTONOLOGIA)",
      listItems: [
        "1.1 FISICA 1 (FISICA BASICA Y DOPPLER GENERALES)",
        "1.2 GINECOLOGIA 1",
        "1.3 GINECOLOGIA 2"
      ]
    },
    {
      title: "MÓDULO II ECOGRAFÍAS DE TAMIZAJE",
      listItems: [
        "2.1. Física 2 (Física del Doppler Ginecoobstétrico)",
        "2.2. Ecografía de 1° trimestre",
        "2.3. Ecografía de 2° trimestre",
      ]
    },
    {
      title: "MÓDULO III CIRCULACIÓN FETO/PLACENTARIA",
      listItems: [
        "3.1. Doppler de Arterias materno fetales",
        "3.2. Doppler Cerebro/placentario",
        "3.3. Doppler fetal avanzado",
        "3.4. RCIU",
        "3.5. Anemia fetal"
      ]
    },
    {
      title: "MÓDULO IV CARDIOPATÍAS FETALES",
      listItems: [
        "4.1. Epidemiología (ISUOG)",
        "4.2. Cardiopatías izquierdas y derechas",
        "Patología fetal (Cirugía fetal)",
        "4.3. Cardiopatías septales y conotruncales",
        "4.4. Cardiopatías miscelaneas",
      ]
    },
    {
      title: "MÓDULO V NEUROSONOGRAFÍA FETAL",
      listItems: [
        "5.1. Neurosonografía básica fetal",
      ]
    }
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#fffff',
        borderRadius: '10px',
        padding: '20px',
        mx: { xs: 0, sm: '30px' },
      }}
    >
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 'bold',
          mb: 4,
          color: '#495057',
        }}
      >
        Módulos del Diplomado
      </Typography>
      <Grid container spacing={5}>
        {moduloData.map((modulo, index) => {
          const isExpanded = expanded[index];

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  background: '#fffff',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  boxShadow: '0px 15px 15px rgba(0, 0, 0, 0.15)',
                  transform: isExpanded ? 'scale(1.03)' : 'scale(1)',
                  opacity: isExpanded ? 1 : 0.95,
                  transition: 'transform 0.5s ease, box-shadow 0.5s ease, opacity 0.5s ease',
                  '&:hover': {
                    boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.2)',
                    transform: 'scale(1.05)',
                  },
                  minHeight: '400px', // Altura mínima para todas las tarjetas
                  display: 'flex', // Para alinear contenido interno
                  flexDirection: 'column', // Ordenar elementos verticalmente
                }}
              >

                <CardContent
                  sx={{
                    padding: '20px',
                    textAlign: 'center',
                    position: 'relative',
                    transition: 'opacity 0.4s ease, transform 0.4s ease',
                    flexGrow: 1, // Permite que el contenido interno ocupe el espacio disponible
                  }}
                >

                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      color: '#343a40',
                      mb: 2,
                      borderBottom: '2px solid #e9ecef',
                      pb: 1,
                    }}
                  >
                    {modulo.title}
                  </Typography>
                  <List
                    sx={{
                      maxHeight: isExpanded ? '300px' : '150px', // Altura máxima: expandida o colapsada
                      overflow: 'hidden', // Ocultar contenido fuera del contenedor
                      transition: 'max-height 0.5s ease, opacity 0.5s ease',
                      opacity: 1, // Mantener opacidad visible siempre
                      position: 'relative',
                      '&::after': {
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        background: 'linear-gradient(to top, #ffffff, transparent)',
                        height: '20px',
                        width: '100%',
                        display: isExpanded ? 'none' : 'block',
                        textAlign: 'center',
                      },
                    }}
                  >
                    {modulo.listItems.map((item, i) => (
                      <ListItem key={i} sx={{ padding: '5px 0' }}>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
                <Button
                  fullWidth
                  onClick={() => handleToggle(index)}
                  sx={{
                    padding: '10px 0',
                    backgroundColor: '#f8f9fa',
                    color: '#495057',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    borderRadius: '0',
                    borderTop: '1px solid #dee2e6',
                    transition: 'background-color 0.3s ease, color 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#e9ecef',
                      color: '#212529',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {isExpanded ? (
                    <>
                      <ExpandLess sx={{ mr: 1 }} />
                      Colapsar
                    </>
                  ) : (
                    <>
                      <ExpandMore sx={{ mr: 1 }} />
                      Expandir
                    </>
                  )}
                </Button>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CourseModules;
